import React from 'react';
import Google from './google.png';

const IconGoogle = () => {
    return (
       <div className="ui-icon">
           <img src={Google} alt="google icon"/>
       </div>
    );
};

export default IconGoogle;
